import type { IconProps } from "@gigpro/ui/Icons";

export const EmptyStateIcon = ({ color = "currentColor", ...props }: IconProps) => {
  return (
    <svg viewBox="10 0 152 149" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.577 135.341C130.83 131.152 133.708 128.612 137.957 127.785C139.872 127.152 136.594 122.669 135.206 124.329C132.744 126.365 124.141 132.791 129.577 135.341ZM108.359 101.598C109.38 100.279 114.873 97.8981 113.938 96.514C112.161 94.9812 109.179 90.8131 106.852 93.491C106.552 94.2582 108.158 94.6527 106.707 95.0434C103.556 95.9386 103.524 95.9625 105.342 98.5665C106.237 99.6138 107.064 101.042 108.359 101.598ZM119.33 119.02C121.419 116.653 123.271 114.076 126.25 112.677C126.908 112.327 127.277 111.748 126.724 111.157C125.567 110.17 124.57 107.352 122.794 108.862C119.201 111.189 113.586 115.639 119.33 119.02ZM144.044 137.402C143.221 135.184 142.253 130.907 139.029 132.652C136.248 134.265 132.408 137.126 132.836 140.652C133.323 141.77 134.441 141.003 135.16 140.596C137.809 138.682 141.408 138.763 144.044 137.402ZM121.911 105.614C120.836 104.136 118.008 99.0987 115.97 100.812C114.383 102.687 109.431 104.212 111.153 107.14C112.04 108.367 113.132 112.326 114.988 110.47C116.818 108.219 120.462 107.901 121.911 105.614ZM125.225 128.73C132.438 118.532 137.631 123.089 130.601 115.637C128.563 113.433 125.466 119.311 123.614 120.379C122.703 121.466 120.783 122.604 121.722 124.229C122.775 125.77 123.202 128.212 125.225 128.73ZM108.992 55.8247C109.856 46.0477 102.917 37.2406 95.9985 31.0195C86.7322 23.8212 72.9321 23.277 62.2811 27.689C43.3413 34.4479 30.1469 55.3182 40.828 74.3664C44.6694 84.0158 53.3261 88.8337 62.9337 91.3267C88.4687 97.0721 108.811 82.4805 108.992 55.8247ZM100.409 93.8683C99.0502 92.6675 98.3838 89.4695 96.3806 90.1544C85.6147 96.1598 72.2117 97.5044 60.4965 93.6386C37.7431 88.2284 27.5239 59.2564 40.1279 40.0243C53.795 16.5105 93.3582 12.1972 107.783 37.1334C118.741 51.4092 113.105 72.5041 102.209 85.2159C100.844 86.296 101.061 87.5095 102.081 88.7684C104.596 94.2866 106.448 82.2786 115.459 91.3443C118.844 94.496 121.806 98.044 124.348 101.909C129.259 109.766 136.287 115.988 140.746 124.144C141.552 127.263 147.993 129.607 145.762 131.331C144.464 133.046 146.687 135.086 147.029 136.894C147.66 138.555 149.798 138.513 151.013 139.594C155.213 144.634 144.912 149.037 140.649 148.385C138.252 147.863 135.118 149.143 133.216 147.267C127.321 139.146 121.831 130.627 116.216 122.221C112.459 116.629 107.838 111.693 104.6 105.748C103.21 102.168 96.2414 97.3357 100.409 93.8683Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6902 98.4046C15.3189 94.5528 32.1426 78.6317 31.7255 86.7171C29.6633 88.6098 18.3767 104.018 16.6902 98.4046Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4785 57.7298C27.0018 59.3279 3.14085 68.292 0.701685 67.8063C-3.91677 64.6762 15.6697 57.5894 18.4785 57.7298Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.936 11.2511C125.166 16.6333 116.584 25.1041 110.883 25.5717C106.525 22.293 123.684 11.2088 126.936 11.2511Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.2448 108.109C88.0634 111.858 87.5216 122.384 82.8292 114.733C79.1262 104.014 87.8264 96.0622 88.2448 108.109Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92859 26.6389C12.0438 27.3466 15.8197 29.91 19.0633 32.4754C21.1918 33.5665 22.7846 38.3764 18.9993 37.4223C16.2607 35.745 13.5764 33.9803 10.8583 32.2704C9.29576 31.2995 7.6987 30.4102 5.87758 29.9804C2.98599 28.21 5.31694 26.4237 7.92859 26.6389Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.4845 104.81C52.2934 108.642 49.4981 114.853 45.3763 115.894C41.2715 114.793 51.7264 96.101 53.4845 104.81Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.0667 23.7899C35.4981 24.6358 31.6646 7.63606 39.3291 13.1347C41.3354 15.8429 40.8898 19.7346 43.1547 22.1588C44.2409 22.9798 42.9146 23.8602 42.0667 23.7899Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.7295 11.1925C67.5465 19.6966 59.5891 2.41186 62.6138 0.0931004C66.4704 -1.02258 68.3919 8.19884 68.7295 11.1925Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.554 75.1725C140.193 75.5363 139.924 76.2156 139.334 76.1053C136.554 75.2371 133.695 75.8145 130.879 75.6641C119.282 73.1904 132.975 66.9106 140.554 75.1725Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.953 50.1417C130.214 50.5865 126.168 48.4074 129.128 47.1388C133.024 46.7012 137.962 46.7636 141.364 48.3584C138.456 49.4533 135.037 49.4479 131.953 50.1417Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.1478 9.3406C91.9865 6.95351 93.7975 0.0414421 96.4927 4.27276C96.6985 7.33988 92.5794 18.3921 92.1478 9.3406Z"
        className="text-black"
      />
    </svg>
  );
};

export const ErrorStateIcon = ({ color = "currentColor", ...props }: IconProps) => {
  return (
    <svg viewBox="0 0 188 138" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.2048 34.1275C98.9651 33.7969 91.6525 28.5559 90.9671 32.6081C90.9194 33.6101 92.2776 34.1714 93.2048 34.1275ZM76.696 85.5601C74.9539 80.2144 73.7198 72.0353 67.8423 69.451C66.5585 69.9852 62.2392 69.6531 63.0411 71.5221C69.1608 76.8909 72.6495 86.1094 67.6413 93.0418C67.2236 93.6594 66.3201 94.4444 67.0377 95.0816C72.9465 96.9965 76.25 89.9656 76.696 85.5601ZM55.1854 93.9991C66.8683 94.4607 66.1498 85.429 61.0314 78.571C59.5041 75.2645 55.2772 75.8233 52.194 74.7365C46.533 73.1634 42.977 79.6087 43.2333 83.9959C44.5538 88.8856 49.1208 94.3433 55.1854 93.9991ZM103.925 33.4563C103.886 33.4563 103.848 33.456 103.809 33.456C106.812 -3.09992 80.625 6.51022 79.7216 35.2665C79.88 43.121 78.279 41.0024 86.5708 43.9137C87.7283 44.2861 88.6575 44.1948 88.4095 42.9226C88.0143 35.4192 82.9339 28.2016 88.0981 21.1912C88.7209 19.7877 91.7355 19.6703 91.8776 21.4601C91.7626 23.5639 87.6095 29.1361 92.3317 28.4326C95.9502 27.9149 101.557 32.2375 98.3129 35.0922C96.2594 36.9413 90.9259 35.0629 90.8328 38.3934C91.0557 40.544 90.8424 44.41 93.6216 45.056C106.833 45.0427 103.607 43.8432 103.925 33.4563ZM110.746 41.1509C112.329 56.1903 85.3498 50.6015 76.7643 46.158C68.8346 37.2227 80.2955 34.7477 59.5289 41.8049C57.3092 43.0765 43.5828 45.2511 45.112 47.4005C59.2039 51.8423 74.2496 55.0801 87.3573 61.6342C88.7432 62.5532 90.1429 63.5894 91.9333 62.7204C97.605 60.3961 103.443 58.4812 109.58 57.5079C112.004 56.842 138.934 52.512 133.154 49.8592C125.706 46.8503 119.141 42.3083 112.048 38.6715C110.526 38.0741 110.862 40.9511 110.746 41.1509ZM41.3347 75.4767C49.7241 69.9867 61.6153 64.1536 71.862 65.8684C78.6127 70.2348 81.2228 78.7184 81.294 85.9982C79.0449 100.45 67.0445 98.1527 55.2734 98.3576C48.744 100.294 43.4069 92.3208 42.5747 94.4794C42.4294 96.7021 41.8375 99.3549 44.8066 100.118C51.8507 103.874 58.9218 107.587 65.9256 111.405C71.9445 114.934 78.0394 118.341 84.3778 121.366C86.0175 118.106 84.3897 113.819 85.3479 110.229C87.1 98.9123 86.4964 87.4637 86.9921 76.0727C86.2468 73.1195 89.2913 68.9769 86.8523 66.8088C72.6965 59.5455 56.3981 56.2609 41.1051 51.4453C39.9395 51.123 39.5288 52.2633 39.6741 53.1571C41.3862 60.5153 38.8931 68.3472 41.3347 75.4767ZM141.389 77.9372C141.345 77.9378 141.302 77.9384 141.258 77.9386C140.818 70.8974 141.214 63.8544 141.365 56.81C141.631 53.8571 137.768 55.5509 136.013 55.842C127.764 58.5927 119.125 59.9366 110.598 61.7296C105.272 62.8414 99.9684 64.0409 94.6419 65.148C91.4979 65.7267 92.3056 69.2271 92.009 71.4174C96.3557 136.436 66.629 122.145 130.439 111.66C133.867 110.198 140.612 110.725 141.863 107.082C141.642 97.365 141.18 87.6626 141.389 77.9372ZM148.311 81.1717C147.803 88.3436 148.086 97.7907 147.345 105.295C146.959 106.892 149.799 106.061 149.293 107.45C148.078 109.106 147.924 113.406 145.404 113.295C129.38 116.531 112.728 120.902 96.3908 124.236C93.4061 124.493 90.3455 127.256 87.4452 125.994C85.7144 125.538 83.5327 126.22 81.893 125.053C72.5226 120.565 63.1535 116.055 53.9616 111.266C49.6435 108.047 38.6138 104.845 37.6312 99.9206C37.7185 87.6413 27.8634 49.2861 41.1566 43.389C50.9515 38.8862 61.4723 35.995 71.7219 32.5328C75.067 31.1702 73.7787 26.3024 75.639 23.6184C78.3383 16.3884 82.7027 9.11651 90.3716 5.56537C98.4778 1.01215 106.712 8.6125 108.561 15.7056C109.737 19.9537 110.243 24.2899 110.506 28.6555C110.601 29.9277 110.188 31.6193 111.796 32.2117C145.488 50.158 146.555 43.3718 148.311 81.1717Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M169.001 77.0444C172.021 77.4546 193.083 80.1902 185.482 84.9217C181.724 85.5025 150.446 78.1027 169.001 77.0444Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5839 72.5831C15.6035 72.9933 36.666 75.7289 29.0648 80.4604C25.3069 81.0412 -5.97088 73.6414 12.5839 72.5831Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6552 29.3835C36.3837 28.1103 20.988 27.0593 19.8559 23.3202C22.4332 19.3607 37.7337 24.2146 42.1225 25.4101C44.4151 26.9579 44.0754 30.0248 40.6552 29.3835Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.291 104.451C178.308 106.263 175.795 108.32 174.217 106.896C169.518 101.982 160.065 101.664 157.133 95.0805C156.962 93.9274 158.632 93.5526 159.499 94.1821C164.951 98.1454 176.069 97.8618 178.291 104.451Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.236 14.3119C142.551 17.748 131.267 31.9475 127.195 29.788C125.131 28.9057 126.402 26.6956 127.431 25.5274C130.701 23.0433 140.23 10.949 144.236 14.3119Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.5311 123.4C54.3789 125.915 47.4423 136.457 43.6652 133.472C40.7368 130.979 55.0205 116.189 56.5311 123.4Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.8817 1.87578C60.3884 6.40993 59.7122 13.1062 55.2679 15.771C48.1911 17.0285 60.0884 -6.70881 61.8817 1.87578Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.729 35.1803C175.502 36.1127 173.161 38.7615 171.313 39.3603C166.067 41.1428 161.02 45.9112 155.427 45.6313C154.583 43.4175 170.064 34.9207 172.729 35.1803Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3347 45.6029C20.1084 46.5353 17.7667 49.1841 15.9187 49.7829C10.6731 51.5654 5.62577 56.3338 0.0333058 56.0539C-0.811447 53.8401 14.6696 45.3433 17.3347 45.6029Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.211 132.138C135.754 131.764 133.126 131.716 130.501 130.01C127.451 130.709 124.119 126.974 124.778 124.325C125.106 123.77 125.648 124.04 126.019 124.253C128.932 125.932 132.276 126.38 135.498 127.169C137.677 127.296 142.946 131.303 139.211 132.138Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.392 62.2499C160.622 60.5127 163.639 56.0605 166.738 56.8783C170.052 59.8635 161.2 65.6552 159.157 67.4607C155.03 68.4419 156.694 63.7939 158.392 62.2499Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.843 131.984C153.726 128.877 156.8 121.086 160.987 121.705C164.448 123.213 153.933 138.984 152.843 131.984Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1502 111.35C22.7986 112.697 14.0437 115.628 18.2821 110.377C24.3233 104.257 37.1524 104.819 25.1502 111.35Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.26 133.984C99.7929 130.987 107.529 124.539 108.838 129.115C108.923 132.828 101.012 143.249 101.26 133.984Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.698 104.391C109.253 104.011 103.61 106.301 103.084 103.522C102.706 102.604 102.593 101.371 103.809 100.947C113.376 99.0996 123.303 99.294 132.815 96.7773C142.58 103.37 115.574 104.578 111.698 104.391Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.371 76.1074C131.835 79.9444 132.097 92.789 125.392 86.4321C125.745 83.7265 124.692 67.4693 129.015 69.2259C133.15 70.7313 131.893 72.8588 132.371 76.1074Z"
        className="text-black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.199 82.4107C112.796 88.8865 105.784 91.7386 103.672 85.0143C103.28 82.3068 103.402 71.9705 107.419 72.6117C110.491 75.0416 111.204 79.0422 111.199 82.4107Z"
        className="text-black"
      />
    </svg>
  );
};
